import map from "lodash/map"
import get from "lodash/get"
import { Component } from "react"
import PropTypes from "prop-types"
import getContentUrl from "utils-lib/getContentUrl"
import { isTeamsitePage } from "utils-lib/isTeamsitePage"
import { getWindow } from "utils-lib/getWindow"
import { isMyWMApp } from "utils-lib/isMyWMApp/index"
import FooterItem from "./components/FooterItem"
import SocialMediaLinks from "../FooterLegal/SocialMediaLinks/SocialMediaLinks"
import { Link } from "../../../Base"
import "./MobileFooter.scss"

const ssrWindow = getWindow()

class MobileFooter extends Component {
  constructor(props) {
    super(props)
    this.state = {
      footerSubSection: ``,
    }
  }

  renderSection(data) {
    const shouldShow =
      get(data, `columnHeading`, ``) === this.state.footerSubSection

    const isExternalLink =
      isMyWMApp || isTeamsitePage(ssrWindow.location.pathname)

    return (
      <div
        className="ml-1 mr-4 d-md-flex"
        style={{
          height: shouldShow ? `auto` : 0,
          marginTop: shouldShow ? `0.5rem` : 0,
          overflow: `hidden`,
          transition: `0.3s all`,
        }}
      >
        {map(data.quickLinks, (item, index1) => (
          <div className="mb-3" key={index1}>
            <Link
              tabIndex={shouldShow ? "0" : "-1"}
              href={item.quickLinkPath}
              analytics_key={item.analyticsKey}
              isExternalLink={isExternalLink || item.isExternalLink}
              className="Footer__quicklink pl-2"
              onClick={() => {
                this.setState({
                  footerSubSection: "",
                })
              }}
            >
              {item.quickLinkText}
            </Link>
          </div>
        ))}
      </div>
    )
  }

  render() {
    const { columns, logo, logolink, socialMediaLinks, logoAltText, strings } =
      this.props

    const { footerSubSection } = this.state

    const isExternalLink =
      isMyWMApp || isTeamsitePage(ssrWindow.location.pathname)

    return (
      <div className="MobileFooter" data-testid="MobileFooter">
        <div className="border-bottom-white pb-3 mb-4">
          <div className="wm-footer-logo footer-main-wrapper justify-content-between align-items-center d-flex">
            <Link
              href={logolink}
              className="mr-4"
              isExternalLink={isExternalLink}
              ariaLabel={strings.SR_LOGO_TEXT}
            >
              <span className="sr-only">{strings.SR_LOGO_TEXT}</span>
              <img
                className="footer-logo"
                src={getContentUrl(logo)}
                alt={logoAltText}
                width="107px"
                height="44px"
              />
            </Link>
          </div>
        </div>
        <div>
          {columns.map((column, index) => (
            <div key={index} className="mb-3">
              <FooterItem
                column={column}
                footerSubSection={footerSubSection}
                updateFooterSubview={(name) => {
                  this.setState((prevState) => ({
                    ...prevState,
                    footerSubSection:
                      prevState.footerSubSection === column.columnHeading
                        ? null
                        : name,
                  }))
                }}
              />
              {this.renderSection(column)}
            </div>
          ))}
          <SocialMediaLinks links={socialMediaLinks} />
        </div>
      </div>
    )
  }
}

MobileFooter.propTypes = {
  columns: PropTypes.array.isRequired,
  logo: PropTypes.string.isRequired,
  logoAltText: PropTypes.string,
  logolink: PropTypes.string.isRequired,
  socialMediaLinks: PropTypes.array.isRequired,
  strings: PropTypes.object,
}

MobileFooter.defaultProps = {
  logoAltText: "footer logo",
  strings: { SR_LOGO_TEXT: "Waste Management Home" },
}

export default MobileFooter
